// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GIfo","question":"styles_question__1vEVG","description":"styles_description__YPkhM"};